import { LargeHeadingStyled } from "src/components/custom/texts/texts.styled";
import { LostSVG } from "src/assets";
import React from "react";
import { Image } from "antd";
import { useNavigate } from "react-router-dom";
import { Button } from "@nubeteck/components";
function NotFound() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "90vh",
        gap: "15px",
      }}
    >
      <Image width={500} src={LostSVG} preview={false} />
      <LargeHeadingStyled>Página no encontrada</LargeHeadingStyled>
      <Button type="primary" onClick={() => navigate("/")}>
        Volver a la página principal
      </Button>
    </div>
  );
}

export default NotFound;
